import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'

const app = Application.start()

app.register('refosumu--example-show--company-card--component', class extends Controller {
  static targets = ['tags', 'toggle', 'toggleText']

  connect() {
    this.boundHandleResize = this.handleResize.bind(this)
    // CSSが適用されてから高さを計算するため少し遅延
    requestAnimationFrame(() => {
      this.checkOverflow()
    })
    window.addEventListener('resize', this.boundHandleResize)
  }

  disconnect() {
    window.removeEventListener('resize', this.boundHandleResize)
  }

  handleResize() {
    this.checkOverflow()
  }

  // SP用タグのオーバーフローチェック
  checkOverflow() {
    if (!this.hasTagsTarget || !this.hasToggleTarget) return

    const tags = this.tagsTarget
    const toggle = this.toggleTarget

    // PC表示時はトグルボタンを非表示
    // screen-md (768px) と同期。変更時は component.scss も確認すること
    const MD_BREAKPOINT = 768
    if (window.innerWidth >= MD_BREAKPOINT) {
      toggle.style.display = 'none'
      tags.classList.remove('is-expanded')
      return
    }

    // 展開中は非表示にしない
    if (tags.classList.contains('is-expanded')) {
      toggle.style.display = 'flex'
      return
    }

    // 一時的にmax-heightを解除して実際の高さを取得
    const originalMaxHeight = tags.style.maxHeight
    const originalOverflow = tags.style.overflow
    tags.style.maxHeight = 'none'
    tags.style.overflow = 'visible'

    const fullHeight = tags.scrollHeight

    // 元に戻す
    tags.style.maxHeight = originalMaxHeight
    tags.style.overflow = originalOverflow

    // CSSのmax-height: 60pxと同じ値を超える場合のみボタンを表示
    // 実際の2行分の高さに余裕を持たせる（タグ高さ26px + gap 8px）* 2 = 68px
    const maxVisibleHeight = 68
    if (fullHeight > maxVisibleHeight) {
      toggle.style.display = 'flex'
    } else {
      toggle.style.display = 'none'
    }
  }

  // SP用タグのトグル
  toggle() {
    const tags = this.tagsTarget
    const toggle = this.toggleTarget
    const toggleText = this.toggleTextTarget
    const isExpanded = tags.classList.contains('is-expanded')

    if (isExpanded) {
      tags.classList.remove('is-expanded')
      toggle.classList.remove('is-expanded')
      toggleText.textContent = 'もっと見る'
      // 閉じた後に再度チェック
      this.checkOverflow()
    } else {
      tags.classList.add('is-expanded')
      toggle.classList.add('is-expanded')
      toggleText.textContent = '閉じる'
    }
  }
})
